import { PictureProps } from "@smile2impress/components/relaunch";
import {
    ElementResponsiveImageProps,
    STRAPI_WEBSITE_API_URL,
} from "api/cms-website";

import {
    getDesktopImageUrl,
    getImageExtenstion,
    getMobileImageUrl,
} from "utils/imageUrl";

export function mapImage(
    image: ElementResponsiveImageProps | undefined,
    lazy?: boolean
): PictureProps {
    const mobileUrl = getMobileImageUrl(image, STRAPI_WEBSITE_API_URL);
    const desktopUrl = getDesktopImageUrl(image, STRAPI_WEBSITE_API_URL);

    const mobileExt = getImageExtenstion(mobileUrl);
    const desktopExt = getImageExtenstion(desktopUrl);

    return {
        defaultSrc: mobileUrl || desktopUrl,
        images: [
            mobileExt && mobileUrl
                ? {
                      [mobileExt]: mobileUrl,
                  }
                : null,
            desktopExt && desktopUrl
                ? {
                      [desktopExt]: desktopUrl,
                  }
                : null,
        ].filter((el) => el),
        ...(lazy ? { loading: "observer" } : {}),
    };
}
